export type {
  Invoice,
  BaseInvoice,
  PlanInvoice,
  SmsInvoice,
  InvoiceProductType,
  InvoiceDetailsResponse,
  InvoiceBulkDownloadSortColumn,
  InvoiceBulkDownloadSortDirection,
  InvoiceBulkDownloadFilterRequest,
} from "@calendall/shared";

export type {
  BillingAddress,
  OrderDetails,
  OrderQuotaDetails,
} from "@calendall/shared";

// Country is not re-exported from the shared index — define locally to match shared shape.
export type Country = { code: string; name: string };

// Shared uses a typo ("Bulkd") — expose correctly-spelled aliases locally.
import type {
  Invoice,
  InvoiceBulkdDownloadRequest,
  InvoiceBulkdDownloadResponse,
  PlanInvoice,
  SmsInvoice,
} from "@calendall/shared";

export type InvoiceBulkDownloadRequest = InvoiceBulkdDownloadRequest;
export type InvoiceBulkDownloadResponse = InvoiceBulkdDownloadResponse;

// ── Runtime helpers ──────────────────────────────────────────────────────────

export function isPlanInvoice(inv: Invoice): inv is PlanInvoice {
  return inv.product.type === "plan";
}

export function isSmsInvoice(inv: Invoice): inv is SmsInvoice {
  return inv.product.type === "sms";
}
